<!--
 * @Description: 
 * @Author: 爱酱丶
 * @Date: 2022-12-08 17:49:39
 * @LastEditTime: 2022-12-08 17:51:50
 * @LastEditors: 爱酱丶
-->
<template>
  <div class="container">
    <PublicHeader :totalName="$t('public').xq" />
    <div class="title">{{ title }}</div>
    <div class="content" v-html="info"></div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeaderNew'
import userApi from '@/api/user'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      info: '',
      title: ''
    }
  },
  async mounted() {
    if (this.$route.query && this.$route.query.info) {
      this.info = this.$route.query.info
      this.title = this.$route.query.title
    } else {
      const type = this.$route.query.type
      this.title =
        type === 'AboutUs' ? this.$t('home').gywm : this.$t('home').bps
      this.info = await userApi.textInfo({
        isWhite: type !== 'AboutUs'
      })
    }
  }
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  width: 60%;
  padding-top: 44px;
}
.title {
  font-size: 16px;
  margin: 20px 0;
  font-weight: bold;
  text-align: center;
}
.content {
  margin: 10px;
  background: #17181e;
  overflow: hidden;
  padding: 10px;
  border-radius: 4px;
}
</style>
